import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

class Html extends PureComponent {
  static propTypes = {
    info: PropTypes.string.isRequired
  }

  render() {
    const {info} = this.props
    {/* eslint-disable */}
    return (<div dangerouslySetInnerHTML={{__html:info}} />)
  }
}

export default Html



// WEBPACK FOOTER //
// ./components/Service_Steps/Info/Html/index.jsx